import { render, staticRenderFns } from "./DataBaseWork.vue?vue&type=template&id=229bf8c8&"
import script from "./DataBaseWork.vue?vue&type=script&lang=js&"
export * from "./DataBaseWork.vue?vue&type=script&lang=js&"
import style0 from "./DataBaseWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports